export function mseIsSupported() {
	return "MediaSource" in window;
}

export const NEXT_VIDEO_THRESHOLD = 0.5;

export type Media = {
	shouldPlayImmediately?: boolean;
	shouldLoop?: boolean;
	data: ArrayBuffer;
	name: string;
	contentType: string;
	navigateAfter?: string;
};
